import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor() { }
  public socialMediaIcons:any[] = [
    {
      type: 'Facebook',
      class: 'fa-brands fa-facebook-f',
      link: 'https://www.facebook.com/people/The-Laboratory-Matters/100093170615490/'
    }, {
      type: 'Instagram',
      class: 'fa-brands fa-instagram',
      link: 'https://www.instagram.com/thelaboratorymatters/'
    }, {
      type: 'Twitter',
      class: 'fa-brands fa-twitter',
      link: 'https://twitter.com/reachTLM'
    }, {
      type: 'LinkedIn',
      class: 'fa-brands fa-linkedin-in',
      link: 'http://www.linkedin.com/company/the-laboratory-matters'
    }
  ]

  ngOnInit(): void {
  }

  onClickLink(link){
    sessionStorage.setItem('activeSection', JSON.stringify(link));
  }

  onClickIcon(icon) {
    window.open(icon.link)
  }

}
